<template>
	<el-col :span="6">
		<el-card :body-style="{ padding: '0px' }" shadow="hover">
			<div
				class="cardContainer"
				@click="editDialogVisible = true"
				@mouseenter="mouseenter"
				@mouseleave="mouseleave"
			>
				<div class="top">
					<p class="activityName">
						{{ listItem.title }}
					</p>
					<el-switch
						v-if="deadLineShow"
						v-model="status"
						:width="28"
						@click.native.stop
						@change="switchChange"
					/>
					<div :class="['tag', { active: status }]">
						{{ status ? '已发布' : '未发布' }}
					</div>
				</div>
				<div class="bottom">
					<div class="statistics">
						<p class="dataTotal">
							总数据
							<span class="num">{{ listItem.totalNum || 0 }}</span>
						</p>
						<span class="line"></span>
						<p class="today">
							今日
							<span class="num">{{ listItem.todayNum || 0 }}</span>
						</p>
					</div>
					<div class="handleBtnContainer" @click.stop>
						<transition name="el-zoom-in-bottom">
							<div v-show="showHandleBtn" class="handleBtn">
								<div
									class="handle"
									@mouseenter="bianjiShow = true"
									@mouseleave="bianjiShow = false"
									@click="editDialogVisible = true"
								>
									<svg class="iconpark-icon"><use href="#bianji"></use></svg>
									<transition name="el-fade-in-linear">
										<div v-show="bianjiShow" class="tooltips">
											编辑
											<div class="popper__arrow"></div>
										</div>
									</transition>
								</div>
								<div
									class="handle"
									@click="dataCount(listItem.id, listItem.title, listItem.totalNum, listItem.oldMark)"
									@mouseenter="tongjiShow = true"
									@mouseleave="tongjiShow = false"
								>
									<svg class="iconpark-icon"><use href="#tongjibaobiao"></use></svg>
									<transition name="el-fade-in-linear">
										<div v-show="tongjiShow" class="tooltips">
											统计
											<div class="popper__arrow"></div>
										</div>
									</transition>
								</div>
								<div
									class="handle"
									@click="shareHandle(listItem.id)"
									@mouseenter="fenxiangShow = true"
									@mouseleave="fenxiangShow = false"
								>
									<svg class="iconpark-icon"><use href="#fenxiang"></use></svg>
									<transition name="el-fade-in-linear">
										<div v-show="fenxiangShow" class="tooltips">
											分享
											<div class="popper__arrow"></div>
										</div>
									</transition>
								</div>
								<div
									class="handle"
									@click="copyDialogVisible = true"
									@mouseenter="fuzhiShow = true"
									@mouseleave="fuzhiShow = false"
								>
									<svg class="iconpark-icon"><use href="#fuzhi"></use></svg>
									<transition name="el-fade-in-linear">
										<div v-show="fuzhiShow" class="tooltips">
											复制
											<div class="popper__arrow"></div>
										</div>
									</transition>
								</div>
								<div
									class="handle"
									@click="deleteDialogVisible = true"
									@mouseenter="shanchuShow = true"
									@mouseleave="shanchuShow = false"
								>
									<svg class="iconpark-icon"><use href="#shanchu"></use></svg>
									<transition name="el-fade-in-linear">
										<div v-show="shanchuShow" class="tooltips">
											删除
											<div class="popper__arrow"></div>
										</div>
									</transition>
								</div>
							</div>
						</transition>
					</div>
				</div>
			</div>
		</el-card>
		<el-dialog :visible.sync="editDialogVisible" width="520px" class="editDialog" :show-close="false">
			<span>
				<svg class="iconpark-icon"><use href="#tixing"></use></svg>
				<span class="text">编辑问卷可能导致已填结果出现偏差,请慎重选择,建议您复制问卷后进行编辑</span>
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" plain @click="copyEditHandle(listItem.id)">复制后编辑</el-button>
				<el-button type="primary" @click="editHandle(listItem.id)">直接编辑</el-button>
				<el-button @click="editDialogVisible = false">取消</el-button>
			</span>
		</el-dialog>
		<el-dialog :visible.sync="shareDialogVisible" title="分享" class="shareDialog" width="600px">
			<span>
				<el-row>
					<el-col :span="16">
						<p>社交网络分享</p>
						<share :config="config" />
						<p id="text">直接访问网址</p>
						<div style="margin-top: 15px">
							<el-input
								v-model="voteURL"
								style="position: relative; z-index: 999"
								class="input-with-select"
								:readonly="true"
							>
								<el-button slot="append" class="copyURL" :data-clipboard-text="voteURL">复制</el-button>
							</el-input>
						</div>
					</el-col>
					<el-col :span="8" class="qrcode">
						<img style="width: 140px; height: 140px" :src="qrcodeUrl" alt="" />
						<p>扫一扫</p>
						<p>分享到微信</p>
					</el-col>
				</el-row>
				<el-row class="sendEmail">
					<p style="margin: 10px 0">发送给参与人员</p>
					<p style="color: #2b313c; font-size: 16px; margin: 0px">已关联活动：{{ listItem.activityTitle }}</p>
					<!-- <p class="sendBtn">
						<el-button
							type="primary"
							:class="sendNum == 0 ? 'noSend' : 'send'"
							v-if="iconShow === 0"
							@click="sendEmail"
							:disabled="sendNum == 0"
						>
							<svg class="icon icon4 " aria-hidden="true">
								<use xlink:href="#icon-fasongyoujian" />
							</svg>
							发送邮件
						</el-button>
						<el-button type="primary" v-else-if="iconShow == 1">
							<svg class="icon icon4 icon5" aria-hidden="true">
								<use xlink:href="#icon-zhengzaifasong" />
							</svg>
							正在发送
						</el-button>
						<el-button type="primary" v-else>
							<svg class="icon icon4 " aria-hidden="true">
								<use xlink:href="#icon-fasongchenggong" />
							</svg>
							发送成功
						</el-button>
						<span style="text-align:center;margin:0 0 10px 0;color:#b8bcc4;display:block;width:100%;"
						>该活动还可发送{{ sendNum }}次</span
						>
					</p> -->
				</el-row>
			</span>
		</el-dialog>
		<el-dialog :visible.sync="deleteDialogVisible" title="确认删除" width="420px" class="copyAndDelDialog">
			<span>确认删除已选择的调查问卷吗</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="deleteDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="deleteHandle(listItem.id)">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog :visible.sync="copyDialogVisible" title="确认复制" width="420px" class="copyAndDelDialog">
			<span>确认复制已选择的调查问卷吗</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="copyDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="copyHandle(listItem.id), (copyDialogVisible = false)"
					>确 定</el-button
				>
			</span>
		</el-dialog>
	</el-col>
</template>
<script>
import conf from '@/config';
import { survey } from '../services/indexnew';
import clipboard from 'clipboard';

export default {
	props: {
		listItem: {
			type: Object,
			// required: true,
			default() {
				return {};
			},
		},
		pageNum: {
			type: Number,
			// required: true,
			default() {
				return null;
			},
		},
		questionnaireAndVoteList: {
			type: Array,
			// required: true,
			default() {
				return [];
			},
		},
		nowTabType: {
			type: Number,
			// required: true,
			default() {
				return null;
			},
		},
		total: {
			type: Number,
			// required: true,
			default() {
				return null;
			},
		},
		pageSize: {
			type: Number,
			default() {
				return null;
			},
		},
	},

	data() {
		const voteAddress = `${conf.surveyHost}/questionnaire/#/questionnaireVote/${this.listItem.id}/write`;
		return {
			status: false,

			showHandleBtn: false,
			bianjiShow: false,
			fenxiangShow: false,
			fuzhiShow: false,
			shanchuShow: false,
			tongjiShow: false,

			editDialogVisible: false,
			shareDialogVisible: false,
			deleteDialogVisible: false,
			copyDialogVisible: false,

			voteURL: voteAddress,
			config: {
				url: voteAddress, // 网址，默认使用 window.location.href
				source: '', // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
				title: '投票页面', // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
				description: '投票页面', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
				image: '', // 图片, 默认取网页中第一个img标签
				sites: ['qzone', 'qq', 'wechat', 'weibo'], // 启用的站点
				disabled: [], // 禁用的站点
				wechatQrcodeTitle: '微信扫一扫：分享', // 微信二维码提示文字
				wechatQrcodeHelper: '<p>扫一扫</p><p>分享到微信</p>',
			},
			qrcode: '',
			deadLineShow: true, //结束时间显示
			cl: null,
			iconShow: 0, //发送邮件图标显示
			sendNum: 3, //发送次数
		};
	},
	computed: {
		qrcodeUrl() {
			return `${conf.ssrUrl}/qrcode/png/${btoa(this.voteURL)}.png?s=200`;
		},
	},
	created() {
		if (this.listItem.status === 1) {
			this.status = true;
		}
		// const nowTime = new Date().getTime();
		// const endTime = new Date(this.listItem.deadLine).getTime();
		// if (nowTime > endTime) {
		// 	this.deadLineShow = false;
		// }
	},
	mounted() {},
	methods: {
		mouseenter() {
			this.showHandleBtn = true;
		},
		mouseleave() {
			this.showHandleBtn = false;
		},
		//初始化数据
		init(pageNum) {
			console.log(pageNum, 'pageNum');
			if (pageNum) {
				this.$emit('childMethod', pageNum);
			} else {
				this.$emit('childMethod');
			}
		},
		//更改发布
		switchChange(value) {
			// console.log(value)
			const id = this.listItem.id;
			survey.setQuestionnaireAndVoteStatus(id).then(({ ok, data }) => {
				if (ok) {
					if (data.flag && data.flag == 50002) {
						this.$message.error(data.msg);
						this.status = !this.status;
						return;
					}
					if (value) {
						if (this.nowTabType) {
							this.$message.success('投票已打开');
						} else {
							this.$message.success('问卷已打开');
						}
					} else {
						if (this.nowTabType) {
							this.$message.success('投票已关闭');
						} else {
							this.$message.success('问卷已关闭');
						}
					}
				} else {
					this.$message.error(data.msg);
				}
			});
			// setQuestionnaireAndVoteStatus(id).then(res => {
			// 	if (res.code === 0) {
			// 		if (value) {
			// 			this.$message.success('问卷已打开');
			// 		} else {
			// 			this.$message.success('问卷已关闭');
			// 		}
			// 	} else {
			// 		this.$message.error(res.msg);
			// 	}
			// });
		},
		//编辑
		editHandle(index) {
			// console.log(this.nowTabType)
			this.editDialogVisible = false;
			this.$router.push({
				path: `/setQuestionnaire/${index}/edit/${this.nowTabType}`,
				// params: { id: index, handle: 'edit', type: this.nowTabType }
			});
			// console.log(index)
		},
		//复制后编辑
		copyEditHandle(index) {
			const id = index;
			survey.copyQuestionnaireAndVote(id).then(({ ok, data }) => {
				if (ok) {
					this.$router.push({
						path: `/setQuestionnaire/${index}/edit/${this.nowTabType}`,
						// params: { id: index, handle: 'edit', type: this.nowTabType }
					});
				} else {
					this.$message.error(data.msg);
				}
			});
		},

		//统计
		dataCount(index, title, total, oldMark) {
			this.$router.push({
				name: 'questionnaireDataStatistics',
				params: { id: index, title: title, total: total },
				query: { oldMark: oldMark ? 1 : 0 },
			});
		},
		//删除
		deleteHandle(index) {
			const id = index;
			//   		console.log(this.questionnaireAndVoteList,'questionnaireAndVoteList')
			// console.log(this.pageNum,'pageNum')
			const questionnaireAndVoteList = this.questionnaireAndVoteList;
			const pageNum = this.pageNum;

			survey.deleteQuestionnaireAndVote(id).then(({ data, ok }) => {
				if (ok) {
					this.$message.success(data.msg);
					this.deleteDialogVisible = false;
					// const total = this.total - 1;
					// var pageNum;
					// console.log(total%this.pageSize)
					// if (total % this.pageSize == 0) {
					//
					// 	pageNum = total / this.pageSize;
					// } else {
					//
					// 	pageNum = parseInt(total / this.pageSize) + 1;
					// }
					if (questionnaireAndVoteList.length - 1 == 0) {
						this.init(pageNum - 1);
					} else {
						this.init(pageNum);
					}
				} else {
					this.$message.error(data.msg);
				}
			});
		},
		//复制
		copyHandle(index) {
			const id = index;
			survey.copyQuestionnaireAndVote(id).then(({ ok, data }) => {
				if (ok) {
					this.$message.success(data.msg);
					this.init();
				} else {
					this.$message.error(data.msg);
				}
			});
		},
		//分享
		shareHandle(index) {
			if (this.listItem.activityId) {
				const activityId = this.listItem.activityId;
				survey.getSendNum(activityId).then(({ ok, data }) => {
					if (ok) {
						this.sendNum = data.data;
					}
				});
			} else {
				this.sendNum = 0;
			}
			this.shareDialogVisible = true;

			if (!this.cl) {
				const self = this;
				setTimeout(() => {
					const cl = new clipboard(this.$el.querySelector('.copyURL'));
					cl.on('success', function (e) {
						self.$message.success('复制成功');
					});
					cl.on('error', function (e) {});
					this.cl = cl;
				}, 10);
			}
		},
		//生成二维码
		// AddQrcode() {
		// 	;
		// 	if (!this.qrcode) {
		// 		this.qrcode = new QRCode('qrcode', {
		// 			width: 120, // 设置宽度
		// 			height: 120, // 设置高度
		// 			text: this.activityURL
		// 		});
		// 	} else {
		// 		this.qrcode.clear(); // clear the code.
		// 		this.qrcode.makeCode(this.activityURL); // make another code.
		// 	}
		// },
		// shareDialogClose(){
		//
		//   this.qrcode.clear()
		// },
		//复制地址
		// copyURL() {
		// 	// this.$router.push({
		// 	//   name:'questionnaireVote',
		// 	//   params:{
		// 	//     id:253,
		// 	//     handle:'show'
		// 	//   },
		// 	//   query:{
		// 	//     type:1
		// 	//   }
		// 	// })
		// 	const DOM = document.getElementById('copyURL');
		// 	console.log(DOM);
		// 	DOM.select(); // 选择对象
		// 	document.execCommand('Copy');
		// 	DOM.click(); // 执行浏览器复制命令
		// 	this.$message.success('复制成功');
		// },
		//发送邮件
		sendEmail() {
			const surveyId = this.listItem.id;
			this.iconShow = 1;
			survey.sendEmail(surveyId).then(({ ok, data }) => {
				if (ok) {
					this.$message.success(data.msg);
					this.sendNum--;
					this.iconShow = 2;
					setTimeout(() => {
						this.iconShow = 0;
					}, 500);
				} else {
					this.$message.error(data.msg);
					this.iconShow = 0;
				}
			});
		},
	},
};
</script>
<style lang="less">
@-webkit-keyframes spin {
	from {
		-webkit-transform: rotate(0deg);
	}
	to {
		-webkit-transform: rotate(360deg);
	}
}
@keyframes spin {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
}
.el-col {
	// padding: 0px 25px 35px 0px;
	margin-bottom: 16px;
	.el-card {
		box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
		&:hover {
			box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
		}
		.cardContainer {
			height: 160px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			&:hover {
				.bottom {
					.handleBtnContainer {
						height: 40px;
					}
				}
			}
		}
		.top {
			box-sizing: border-box;
			padding: 16px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			position: relative;
			p {
				color: #b8bcc4;
				flex: 1;
				&.activityName {
					font-size: 16px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					color: rgba(29, 33, 41, 1);
				}
			}
			.el-switch {
				.el-switch__core {
					height: 16px;
					&:after {
						width: 10px;
						height: 10px;
						top: 2px;
						left: 3px;
					}
				}
			}
			.el-switch.is-checked .el-switch__core {
				background: rgba(22, 93, 255, 1);
				border-color: rgba(22, 93, 255, 1);
				&:after {
					left: 100%;
					margin-left: -13px;
				}
			}
			.tag {
				position: absolute;
				width: 92px;
				height: 48px;
				background: rgba(242, 243, 245, 1);
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: 24px;
				transform: scale(0.5);
				transform-origin: left top;
				top: 44px;
				left: 16px;
				color: rgba(134, 144, 156, 1);
				&.active {
					background: rgba(255, 247, 232, 1);
					color: rgba(247, 114, 52, 1);
				}
			}
		}

		.bottom {
			.statistics {
				display: flex;
				align-items: center;
				color: rgba(78, 89, 105, 1);
				font-size: 14px;
				line-height: 22px;
				padding: 0 16px 16px;
				transition: 0.2s;
				p {
					display: flex;
					align-items: center;
				}
				.dataTotal {
					width: 50%;
				}
				.line {
					width: 1px;
					height: 12px;
					background-color: rgba(229, 230, 232, 1);
					margin-right: 24px;
				}
				span.num {
					font-size: 16px;
					font-weight: bold;
					color: rgba(52, 145, 250, 1);
					margin-left: 12px;
				}
			}
			.handleBtnContainer {
				height: 0px;
				transition: 0.3s height cubic-bezier(0.23, 1, 0.32, 1);
			}
			.handleBtn {
				display: flex;
				padding: 0 16px;
				background: rgba(247, 248, 250, 1);
				justify-content: space-between;
				align-items: center;
				.handle {
					display: inline-block;
					position: relative;
					height: 40px;
					width: 40px;
					padding: 10px;
					cursor: pointer;
					.iconpark-icon {
						font-size: 20px;
						fill: rgba(169, 174, 184, 1);
					}
					.tooltips {
						position: absolute;
						top: -36px;
						left: 50%;
						transform: translateX(-50%);
						background: #303133;
						color: #fff;
						border-radius: 4px;
						padding: 10px;
						font-size: 12px;
						line-height: 1.2;
						min-width: 10px;
						white-space: nowrap;
						word-wrap: break-word;
						.popper__arrow {
							position: absolute;
							left: 50%;
							transform: translateX(-50%);
							display: block;
							width: 0;
							height: 0;
							border-color: transparent;
							border-style: solid;
							border-width: 6px;
							bottom: -6px;
							border-top-color: #303133;
							border-bottom-width: 0;
						}
					}
					&:hover {
						.iconpark-icon {
							fill: rgba(52, 145, 250, 1);
						}
					}
				}
			}
		}
	}
	.editDialog {
		.el-dialog {
			padding: 0 123px;
			text-align: center;
			.el-dialog__header {
				padding: 0;
			}
			.el-dialog__body {
				padding: 40px 0 12px;
				.iconpark-icon {
					height: 45px;
					width: 45px;
					margin-bottom: 22px;
				}
				.text {
					display: block;
					color: rgba(29, 33, 41, 1);
					font-size: 12px;
					line-height: 20px;
					padding: 0 10px;
				}
			}
			.el-dialog__footer {
				padding: 12px 0 34px;
				span {
					display: flex;
					justify-content: space-between;
					width: 100%;
					.el-button {
						font-size: 14px;
						height: 32px;
						position: relative;
						padding: 5px 16px;
					}
					.el-button--primary {
						background: rgba(52, 145, 250, 1);
						border: none;
						color: rgba(255, 255, 255, 1);
					}
					.el-button--primary.is-plain {
						background: rgba(242, 243, 245, 1);
						border: none;
						color: rgba(52, 145, 250, 1);
					}
					.el-button--default {
						border: 1px solid rgba(134, 144, 156, 1);
						color: rgba(78, 89, 105, 1);
					}
				}
			}
		}
	}
	.shareDialog {
		.el-dialog__header {
			padding-bottom: 20px;
			border-bottom: 1px solid #d8dbe0;
		}
		.el-input {
			.el-input-group__append {
				background-color: #2c7dfa;
				color: #fff;
			}
		}
		.sendEmail {
			height: 210px;
			border-top: 1px solid #d8dbe0;
			.sendBtn {
				text-align: center;
				margin-top: 50px;
				margin-bottom: 5px;
				position: absolute;
				left: 50%;
				transform: translate(-50%);
				bottom: 0;
				.el-button {
					width: 120px;
					height: 42px;
					background: #2c7dfa;
					&.noSend {
						background: #409eff;
					}
				}
				.icon4 {
					width: 16px;
					height: 16px;
					color: #fff;
				}
				.icon5 {
					/*-webkit-transform: rotate(360deg);
                transform: rotate(360deg);
                -webkit-transition: -webkit-transform 1s linear;
                transition: transform 1s linear;*/
					-webkit-animation: spin 1s linear 1s 5 alternate;
					animation: spin 1s linear infinite;
				}
			}
		}
		.el-col-8 {
			text-align: center;
			box-sizing: border-box;
			padding-top: 10px;
			padding-bottom: 0;
			#qrcode {
				width: 120px;
				position: relative;
				left: 20px;
				margin-bottom: 10px;
			}
			p {
				margin: 0;
			}
		}
		.el-dialog__body {
			padding-bottom: 0px;
			.qrcode {
				padding: 0;
			}
		}
		.el-dialog__footer {
			height: 0;
			padding: 0;
		}
	}
}
.copyAndDelDialog {
	.el-dialog {
		height: 188px;
		.el-dialog__header {
			font-size: 16px;
			color: #333333;
		}
		.el-dialog__body {
			padding-left: 58px;
			font-size: 14px;
			color: #333333;
		}
		.el-dialog__footer {
			padding: 0 20px 0 0;
		}
	}
}
.el-col:nth-child(3n) {
	padding-right: 0;
}
</style>
